<template>
  <div class="All">
    <!-- 这个是竞赛主体 -->
    <div class="LeftBody">
      <!-- 搜索框 -->
      <div>
        <el-input
          clearable
          placeholder="请输入比赛名称进行搜索"
          prefix-icon="el-icon-search"
          v-model="input"
          @keyup.native.enter="SearchCompete(input, type, status)">
        </el-input>
      </div>
      <!-- 一行字：等你来战 -->
      <!-- <div class="One">
        <span style="margin-left: 10px; display: block; width: 335px;">等你来战 !</span>
        <el-button style="height: 40px; margin-top:5px" type="primary" plain @click="TheTimes = ''">全部比赛</el-button>
        <el-button style="margin-left: 20px; height: 40px; margin-top:5px" type="success" plain @click="TheTimes = '2'">AL-萌新赛</el-button>
        <el-button style="margin-left: 20px; height: 40px; margin-top:5px" type="warning" plain @click="TheTimes = '2.5'">AL-拔高赛</el-button>
        <el-button style="margin-left: 20px; height: 40px; margin-top:5px" type="danger" plain @click="TheTimes = '3'"> AL-挑战赛</el-button>
      </div> -->
      <div class="header">
        <div style="font-size: 14px; border-bottom: 1px solid lightgrey; padding: 5px 5px 10px 5px;">
          AL系列赛：包含大量AL原创比赛、经典题组合赛、高质量集训营。参加AL比赛，帮助竞赛选手快速提升。
        </div>
        
        <div style="margin-top: 4px;">
          <span style="font-weight: 600; font-size: 15px; padding-left: 5px; margin-right: 10px;">类型</span>
          <el-button @click="Show(1)" :style="obj1" type="text">全部</el-button>
          <el-button @click="Show(2)" :style="obj2" type="text">萌新赛</el-button>
          <el-button @click="Show(3)" :style="obj3" type="text">拔高赛</el-button>
          <el-button @click="Show(4)" :style="obj4" type="text">挑战赛</el-button>
          
        </div>
        
        <div style="margin-top: 4px; padding-bottom: 10px;">
          <span style="font-weight: 600; font-size: 15px; padding-left: 5px; margin-right: 10px;">状态</span>
          <el-button @click="Open(5)" :style="obj5" type="text">全部</el-button>
          <el-button @click="Open(6)" :style="obj6" type="text">已报名</el-button>
          <el-button @click="Open(7)" :style="obj7" type="text">未报名</el-button>
        </div>

      </div>
      <!-- 已经开始的 -->
      <div v-if="list1" style="margin-top: 30px;
          display: flex;
          float: left;
          width: 100%;
          height: 20px;
          line-height: 20px;
          font-size:16px;
          font-weight: bold;/* 字体加粗 */
          
          ">
        <span style="display: block; width: 450px; border-left: 5px solid  #25BB9B;">已开始</span>
      </div>
      <!-- 已经开始的比赛 建议用组件封装好 然后传参进去-->
      <div v-if="list1" class="body">
        <div v-for="c in list1" :key="c.id">
          <BeginCompete :content="c"></BeginCompete>
        </div>
      </div>
      <!-- 可以报名的 -->
      <div v-if="list2" style="margin-top: 30px;
          display: flex;
          float: left;
          width: 100%;
          height: 20px;
          line-height: 20px;
          font-size:16px;
          font-weight: bold;/* 字体加粗 */
          
          ">
        <span style="display: block; width: 450px; border-left: 5px solid  #25BB9B;">等你来战</span>
      </div>
      <!-- 最近可以报名的比赛 建议用组件封装好 然后传参进去-->
      <div v-if="list2" class="body">
        <div v-for="c in list2" :key="c.id">
          <Cancompete :content="c"></Cancompete>
        </div>
      </div>
      <!-- 已经结束的 -->
      <div v-if="list3" style="margin-top: 30px;
          display: flex;
          float: left;
          width: 100%;
          height: 20px;
          line-height: 20px;
          font-size:16px;
          font-weight: bold;/* 字体加粗 */
          
          ">
        <span style="display: block; width: 450px; border-left: 5px solid  #25BB9B;">已结束</span>
      </div>
      <!-- 这里是已经结束的比赛 也建议用组件封装好 然后传参进去 -->
      <div v-if="list3" class="body">
        <div v-for="f in list3" :key="f.id">
          <Finishcompete :content="f"></Finishcompete>
        </div>
      </div>
      <el-empty v-if="list1 === null && list2 === null && list3 === null" description="已经到底啦"></el-empty>
    </div>
    <!-- 一个是右边的Rating排行榜 也用一个组件封装好-->
    <div class="RightBody">
      <Rank></Rank>
    </div>
  </div>
</template>

<script>
  import Url from '@/constant/Url'
  import $ from 'jquery'
  import { nanoid } from 'nanoid'
  import BeginCompete from '@/components/TheSweepstakes/BeginCompete.vue'
  import Cancompete from '../components/TheSweepstakes/Cancompete.vue'
  import Finishcompete from '../components/TheSweepstakes/Finishcompete.vue'
  import Rank from '../components/TheSweepstakes/Rank.vue'

  export default {
    name:'Sweepstakes',
    components: {
      BeginCompete,
      Cancompete,
      Finishcompete,
      Rank,
    },
    data() {
      return {
        objClose: {
          width: "58px",
          height: "24px",
          color: "#303133", 
          padding: "2px", 
          "margin-left": "10px",
        },
        objShow: {
          width: "58px",
          height: "24px",
          "background-color": "#25BB9B",
          color: "white", 
          padding: "2px", 
          "margin-left": "10px",
        },
        obj1: {}, obj2: {}, obj3: {}, obj4: {}, // 四种类型的样式  
        obj5: {}, obj6: {}, obj7: {}, // 报名和未报名的样式

        list:[],
        list1:null,
        list2:null,
        list3:null,

        input:'',
        type:'',
        status:'',
      }
    },
    created() {
      this.obj1 = this.objShow
      this.obj2 = this.obj3 = this.obj4 = this.objClose
      this.type = "全部"
      this.obj5 = this.objShow
      this.obj6 = this.obj7 = this.objClose
      this.status = "全部"
      this.ReadCompeteList()
    },
    methods: {
      ReadCompeteList() {
        const vue = this
        
        $.ajax({
          url: Url.sCompeteUrl,
          type: 'post',
          success(resp) {
            if (resp.error_message === "success") {
              if (resp.register !== null)  vue.list2 = JSON.parse(resp.register)
              if (resp.already !== null) vue.list1 = JSON.parse(resp.already)
              if (resp.finish !== null) vue.list3 = JSON.parse(resp.finish)
            }
          }
        })
      },
      SearchCompete(input, type, status) {
        const store = this.$store
        const vue = this

        $.ajax({
          url: Url.SearchCompeteUrl,
          type:'post',
          data: {
            input: input,
            type: type,
            status: status,
            userId: store.state.me.id,
          },
          headers: {
            Authorization: "Bearer " + store.state.me.token,
          },
          success(resp) {
            if (resp.error_message === "success") {
              console.log("收到了")
              if (resp.register !== null)  vue.list2 = JSON.parse(resp.register)
              else vue.list2 = null
              if (resp.already !== null) vue.list1 = JSON.parse(resp.already)
              else vue.list1 = null
              if (resp.finish !== null) vue.list3 = JSON.parse(resp.finish)
              else vue.list3 = null
              console.log("list1 == >", vue.list1)
              console.log("list2 == >", vue.list2)
              console.log("list3 == >", vue.list3) 
            }
          }
        })
      },
      Show(id) {
        if (id === 1) {
          this.obj1 = this.objShow
          this.obj2 = this.obj3 = this.obj4 = this.objClose
          this.type = "全部"
        } else if (id === 2) {
          this.obj2 = this.objShow
          this.obj1 = this.obj3 = this.obj4 = this.objClose
          this.type = "萌新赛"
        } else if (id === 3) {
          this.obj3 = this.objShow
          this.obj2 = this.obj1 = this.obj4 = this.objClose
          this.type = "拔高赛"
        } else {
          this.obj4 = this.objShow
          this.obj2 = this.obj3 = this.obj1 = this.objClose
          this.type = "挑战赛"
        }
        this.SearchCompete(this.input, this.type, this.status)
      },
      Open(id) {
        if (id === 5) {
          this.obj5 = this.objShow
          this.obj6 = this.obj7 = this.objClose
          this.status = "全部"
        } else if (id === 6) {
          this.obj6 = this.objShow
          this.obj5 = this.obj7 = this.objClose
          this.status = "已报名"
        } else {
          this.obj7 = this.objShow
          this.obj6 = this.obj5 = this.objClose
          this.status = "未报名"
        }
        this.SearchCompete(this.input, this.type, this.status)
      },
    }
  }
</script>

<style scoped>
.header {
  margin-top: 10px;
  padding: 10px;
  width: 100%;
  min-height: 100px;
  height: auto;
  background-color: #F4F4F4;
}
.All {
  margin-top:20px;
  display: flex;
  justify-content: center;
}
.LeftBody {
  width: 840px;
  min-height: 800px;
  height: auto;
  /* background-color: white; */
}
.RightBody {
  margin-left: 35px;
  width: 300px;
  height: 380px;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  border-radius: 2px;
}
.Select {
  margin-top:20px;
  width: 100%;
  height: 80px;
  background-color: red;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}
.One {
  margin-top: 10px;
  display: flex;
  float: left;
  width: 100%;
  height: 54px;
  line-height: 54px;
  background-color:white;
  /* padding: 10px; */
  font-size:16px;
  font-weight: bold;/* 字体加粗 */
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}
.body{
  margin-top: 10px;
  width: 100%;
  height: auto;
  clear:both;/* 清楚上一个div浮动对其的影响 */
  background-color: white;
}
</style>